import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import {TaskModel} from "../../../../tasks/models/task.model";
import {Service} from "../../../../deliveries/models/service.model";
import * as _ from "lodash";

require('./entity-relations-indicator.scss');
@Component({
  standalone: false,
  selector: 'app-entity-relations-indicator',
  templateUrl: './entity-relations-indicator.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EntityRelationsIndicatorComponent implements OnInit, OnChanges {

  @Input() service: Service;
  @Input() task: TaskModel;
  @Input() job: any;
  @Output() onClick = new EventEmitter<null>();

  public count: number;

  constructor() {
  }

  ngOnInit() {
    this.initCount();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.service && !changes.service.isFirstChange()) {
      this.initCount();
    }
    if (changes.task && !changes.task.isFirstChange()) {
      this.initCount();
    }
    if (changes.job && !changes.job.isFirstChange()) {
      this.initCount();
    }
  }

  private initCount() {
    if (this.service) {
      this.count = _.sumBy(this.service.taskList, function (t) {
        return _.get(t, 'relations.length', 0);
      });
    }
    if (this.task) {
      this.count = _.get(this.task, 'relations.length', 0);
    }
    if (this.job) {
      this.count = _.sumBy(this.job.stops, function (s) {
        return _.get(s, 'relations.length', 0);
      });
    }
  }
}
